import { render, staticRenderFns } from "./widgetSecAptMalFileTopn.vue?vue&type=template&id=74772e32&scoped=true&"
import script from "./widgetSecAptMalFileTopn.vue?vue&type=script&lang=js&"
export * from "./widgetSecAptMalFileTopn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74772e32",
  null
  
)

export default component.exports